/* eslint-disable no-bitwise */

export type SeedRng = {
  nextUint32: () => number;
  nextFloat: () => number;
  int: (n: number) => number;
  range: (a: number, b: number) => number;
  getState: () => [number, number, number, number];
};

function mix32(str: string, seed = 0): number {
  let h = (seed ^ str.length) >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x85ebca6b) >>> 0;
    h ^= h >>> 13;
  }
  h ^= h >>> 16;
  h = Math.imul(h, 0xc2b2ae35) >>> 0;
  h ^= h >>> 16;
  return h >>> 0;
}

function seedToState4(seedStr: string): [number, number, number, number] {
  const s0 = mix32(seedStr, 0x243f6a88);
  const s1 = mix32(seedStr, 0x85a308d3);
  const s2 = mix32(seedStr, 0x13198a2e);
  const s3 = mix32(seedStr, 0x03707344);

  if ((s0 | s1 | s2 | s3) === 0) return [1, 0, 0, 0];
  return [s0, s1, s2, s3];
}

export function makeXorShift128(seedStr: string): SeedRng {
  let [x, y, z, w] = seedToState4(seedStr);

  function nextUint32(): number {
    const t = (x ^ (x << 11)) >>> 0;
    x = y;
    y = z;
    z = w;
    w = (w ^ (w >>> 19) ^ (t ^ (t >>> 8))) >>> 0;
    return w;
  }

  function nextFloat(): number {
    return nextUint32() * 2.3283064365386963e-10;
  }

  function int(n: number): number {
    return (nextFloat() * n) | 0;
  }

  function range(a: number, b: number): number {
    return a + (b - a) * nextFloat();
  }

  function getState(): [number, number, number, number] {
    return [x, y, z, w];
  }

  return { nextUint32, nextFloat, int, range, getState };
}

export function shuffleArray<T>(a: T[], rng: SeedRng): T[] {
  const o = [...a];
  for (let i = o.length - 1; i > 0; i--) {
    const j = Math.floor(rng.nextFloat() * (i + 1));
    [o[i], o[j]] = [o[j], o[i]];
  }
  return o;
}
